import { PC_PROCESSING } from 'constants/index';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const useDeliverySettings = (pcProcessing: string) => {
  const configReducer = useSelector((state: RootState) => state.configReducer);
  const deliverySettings: any[] = configReducer?.generalConfig?.deliverySetting;

  const pcReturnOptions: string[] = [PC_PROCESSING.PC_RETURN, PC_PROCESSING.PC_RETURN_UNKNOWN];

  const mappedDeliverySettings = useMemo(() => {
    if (!Array.isArray(deliverySettings)) return [];

    const isReturnSetting = pcReturnOptions.includes(pcProcessing);
    return deliverySettings.map(setting => {
      const { returnSettings, requestSettings, types = [], ...rest } = setting;
      if (types.length > 0 && !types.includes(pcProcessing)) return null;
      return {
        ...rest,
        ...(isReturnSetting ? returnSettings : requestSettings),
      };
    }).filter(Boolean);
  }, [deliverySettings, pcProcessing]);

  const hasDeliverySettings = (userCountry: string) => {
    const hasData = Array.isArray(mappedDeliverySettings) && mappedDeliverySettings?.length;
    const matchedCountry = hasData ? mappedDeliverySettings?.some((setting) => setting?.country?.toLowerCase() === userCountry?.toLowerCase()) : null;
    return matchedCountry;
  };

  return { deliverySettings: mappedDeliverySettings, hasDeliverySettings };
};
